import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* IE and Edge */
    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari and Opera */
    }
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
    line-height: 1.6;
    color: rgba(0, 0, 0, 0.85);
    letter-spacing: -0.02em;
    overflow-x: hidden;
    scroll-behavior: smooth;
    /* 移动端支持安全区域 */
    @media (max-width: 900px) {
      background-color: #000000;
      @media (prefers-color-scheme: light) {
        background-color: #f5f5f7;
      }
      padding-top: env(safe-area-inset-top);
      padding-bottom: env(safe-area-inset-bottom);
    }
  }

  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
`;

export default GlobalStyles;
